import publicConfig from "config/public";
import { useSelector } from "react-redux";

import { getDomainCountryCode } from "redux/selectors/config";

const { cookieDomain, cookieDomainCa } = publicConfig;

export const getCookieDomainFromContext = (countryCode: string) =>
  countryCode === "CA" ? cookieDomainCa : cookieDomain;

export const useCookieDomain = () =>
  getCookieDomainFromContext(useSelector(getDomainCountryCode));
